import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-magnify-field-search',
  templateUrl: './magnify-field-search.component.html',
  styleUrls: ['./magnify-field-search.component.css']
})
export class MagnifyFieldSearchComponent implements OnInit {

  @Input() fieldMappingDetailId: number = 0;
  @Input() predefinedTableColumnName: string = 'id';
  @Input() predefinedTableTextColumnName: string = 'name';
  @Input() dependantFieldValues: any = {};
  advanceSearchGridData: any = [];
  advanceSearchColumnsToHide: any = ['id', 'is_favourite'];
  advanceSeachSelectedRecord: any = {};
  advanceSearchColumns: any = [];
  isAdvanceSearchFavourites: boolean = false;
  isAdvanceSearchHistoricalData: Boolean = false;
  frmAdvanceSearchColumns: FormGroup;
  advanceSearchModalRef: any;
  @ViewChild('advanceSearchModal') advanceSearchModal: ElementRef;
  @Output() selectRecord: EventEmitter<any> = new EventEmitter();
  @Output() closeModal: EventEmitter<void> = new EventEmitter();

  constructor(private dataService: DataService, private commonService: CommonService,private memorystore: MemoryStorageService) { }

  ngOnInit(): void {
    this.getAdvanceSearchData();
  }

  getAdvanceSearchData() {

    this.advanceSearchGridData = [];
    let searchColumns = {};
    this.advanceSearchColumns.forEach(async col => {
      if (this.frmAdvanceSearchColumns.get(col).value != '') {
        searchColumns[col] = this.frmAdvanceSearchColumns.get(col).value;
      }
    });

    let params = {
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      field_mapping_detail_id: this.fieldMappingDetailId,
      search_columns: searchColumns,
      is_favourite: this.isAdvanceSearchFavourites ? 1 : 0,
      is_historical: this.isAdvanceSearchHistoricalData ? 1 : 0,
      page: 1,
      //rows_per_page: 100,
      dependant_field_values: this.dependantFieldValues
    }

    this.dataService.postData('magnify', params).subscribe(res => {
      if (res != null && res.data != null && res.data.length > 0) {

        this.advanceSearchColumns = res.data[0].magnify_search_fields;
        const formControls: any = {};
        this.advanceSearchColumns.forEach(async col => {
          formControls[col] = new FormControl('', []);
        });
        this.frmAdvanceSearchColumns = new FormGroup(formControls);

        res.data[0].magnify_search_table.forEach(x => {
          let obj = {};
          obj['action_radio_button'] = '';
          obj['action_icon_favourite'] = x.is_favourite == 1 ? 'star' : 'star_border';
          Object.keys(x).forEach(k => {
            obj[k] = x[k];
          });
          this.advanceSearchGridData.push(obj);
        });
      }
    });
  }

  advanceSearchCellClick(event: any) {

    if (event.columnName == 'action_icon_favourite') {
      const isFavourite = this.advanceSearchGridData[event.rowIndex].action_icon_favourite != 'star_border';
      this.advanceSearchGridData[event.rowIndex].action_icon_favourite = isFavourite ? 'star_border' : 'star';
      if (isFavourite) {
        this.removeFavourite(this.advanceSearchGridData[event.rowIndex].id);
      } else {
        this.addToFavourite(this.advanceSearchGridData[event.rowIndex].id);
      }
    }
    if (event.columnName == 'action_radio_button') {
      this.advanceSeachSelectedRecord = event.rowData;
    }
  }

  changeAdvanceSeachRadio(flag: string) {
    this.isAdvanceSearchFavourites = false;
    this.isAdvanceSearchHistoricalData = false;
    if (flag == 'favourite') {
      this.isAdvanceSearchFavourites = true;
    }
    if (flag == 'historical') {
      this.isAdvanceSearchHistoricalData = true;
    }
    this.getAdvanceSearchData();
  }

  addToFavourite(id: number) {
    let params = {
      field_mapping_detail_id: this.fieldMappingDetailId,
      selected_id: id
    }

    this.dataService.postData('magnify-favourite', params).subscribe(res => {
    });
  }

  removeFavourite(id: number) {
    let params = {
      field_mapping_detail_id: this.fieldMappingDetailId,
      selected_id: id,
      for_delete: true
    }

    this.dataService.deleteData('magnify-favourite', params).subscribe(res => {
    });
  }

  submitAdvanceSearchResult() {

    if (this.fieldMappingDetailId != 0 && this.advanceSeachSelectedRecord.hasOwnProperty('id')) {
      this.selectRecord.emit({ 'fieldId': this.fieldMappingDetailId, 'fieldValue': this.advanceSeachSelectedRecord[this.predefinedTableColumnName], 'selectedText': this.advanceSeachSelectedRecord[this.predefinedTableTextColumnName.toLowerCase()] });
    } else {
      alert('Please select record');
    }
  }

  dismissModal() {
    this.closeModal.emit();
  }
}
